export const isObject = (object: any) => object != null && typeof object === 'object';

export const deepEqual = (object1: any, object2: any) => {
    //delete undefined values
    Object.keys(object1).forEach(key => object1[key] === undefined && delete object1[key])
    Object.keys(object2).forEach(key => object2[key] === undefined && delete object2[key])
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2 //eslint-disable-line
        ) {
            return false;
        }
    }
    return true;
};

export const isEmptyObject = (obj: any) => typeof obj === 'object' && Object.keys(obj).length === 0;
